import { Modal } from 'react-bootstrap';
import { Typography } from 'app/components';
import { i18n, i18nTemplate } from 'app/utils/i18n';

import '../RemoveModal/RemoveModal.scss';

interface AffectedTagsModalProps {
  show: boolean;
  affectedCount: number;
  itemLabel: string;
  onClose: () => void;
  onGoToTags: () => void;
}

export const AffectedTagsModal = ({ show, affectedCount, itemLabel, onClose, onGoToTags }: AffectedTagsModalProps) => {
  return (
    <Modal show={show} centered dialogClassName="remove-modal-dialog" contentClassName="remove-modal">
      <Modal.Body className="remove-modal__content">
        <Typography variant="body-8" fontWeight="semibold">
          {i18n('tag.affected.title')}
        </Typography>

        <Typography variant="body-7">{i18nTemplate('tag.affected.description', { count: affectedCount, label: itemLabel })}</Typography>

        <div className="remove-modal__actions">
          <button className="btn btn-primary" onClick={onGoToTags}>
            {i18n('tag.affected.go.to.tags')}
          </button>

          <button className="btn btn-secondary" onClick={onClose}>
            {i18n('common.cancel')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
